export default class SmartphoneSetupEvent {
    constructor(type) {
        this.type = type;
    }
}

SmartphoneSetupEvent.PERFORM = "SmartphoneSetupEvent.PERFORM";